export default __webpack_public_path__ + "static/media/arrow__left.07ffbec0.svg";